import { OptimizedMachineTimes } from "./computeOptimizedMachineTimes";
import { OptimizedMaterialCosts } from "./computeOptimizedMaterialCosts";

type OptimizableLine = {
  id: string;
  processSteps: { id: string }[];
};

type OptimizableAssembly = {
  quoteRequestLine: OptimizableLine;
  children: OptimizableAssembly[];
};

type Optimizations = {
  optimizedMachineTimes: OptimizedMachineTimes;
  optimizedMaterialCosts: OptimizedMaterialCosts;
};

export const isQuoteRequestLineOptimized = ({
  quoteRequestLine,
  optimizedMachineTimes,
  optimizedMaterialCosts,
}: Optimizations & { quoteRequestLine: OptimizableLine }): boolean =>
  optimizedMaterialCosts.has(quoteRequestLine.id) ||
  quoteRequestLine.processSteps.some((step) => optimizedMachineTimes.has(step.id));

export const isAssemblyOptimized = ({
  assembly,
  ...optimizations
}: Optimizations & { assembly: OptimizableAssembly }): boolean =>
  isQuoteRequestLineOptimized({ quoteRequestLine: assembly.quoteRequestLine, ...optimizations }) ||
  assembly.children.some((child) => isAssemblyOptimized({ assembly: child, ...optimizations }));
